export default "__VITE_ASSET__B4YB$vZ4__"